export default __webpack_public_path__ + "7f7d4245513e667d8f641f482ba76fc7.png";